import { Injectable } from '@angular/core';
import {
  ChatContactsResponse,
  ChatHttpService,
} from '@app/core/async-services/http/versioned';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as ContactActions from './contact.actions';

@Injectable()
export class ContactEffects {
  loadContacts = createEffect(() =>
    this.actions.pipe(
      ofType(ContactActions.loadContacts),
      mergeMap(() =>
        this.chatHttpService.getChatContacts().pipe(
          map(({ payload }) =>
            ContactActions.loadContactsSuccess({
              contacts: payload.availablePeople,
            }),
          ),
          catchError(({ message }: ChatContactsResponse) =>
            of(ContactActions.loadContactsFailure({ message: message || '' })),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions: Actions,
    private chatHttpService: ChatHttpService,
  ) {}
}
